import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDungeon, faHatWizard, faBookDead, faScroll } from '@fortawesome/free-solid-svg-icons';

const DKPEventItem = (props) => (
    <div className="panel-adt">
        <Link to={"/dkp/events/" + props.event.slug} ><h5>{props.event.title}</h5></Link>
        <span> <FontAwesomeIcon className="text-primary" icon={faDungeon} fixedWidth /> {props.event.location.map((location) => props.locations.data[location].title).join(", ")}</span>
        <span> <FontAwesomeIcon className="text-primary" icon={faBookDead} fixedWidth /> <span className="text-primary">{props.event.entities.length}</span></span>
        <span> <FontAwesomeIcon className="text-primary" icon={faHatWizard} fixedWidth /> <span className="text-primary">{props.event.awardedItems.length}</span></span>
        <span> <FontAwesomeIcon className="text-primary" icon={faScroll} fixedWidth /> <span className="text-primary">{
            (
                props.event.dkp * (new Date(props.event.stopped).getTime() - new Date(props.event.started).getTime()) / (3600 * 1000)
                + props.event.entities.reduce((total, entity) => total + parseFloat(props.eventEntities.data[entity].dkp), 0)
            ).toFixed(2)
        }</span> in <span className="text-primary">{((new Date(props.event.stopped).getTime() - new Date(props.event.started).getTime()) / (3600 * 1000)).toFixed(1)}</span> hours
        </span>
    </div>
);


export default DKPEventItem;


// WEBPACK FOOTER //
// ./src/DKP/DKPEventItem.js